import React, { Component } from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Map, List, fromJS } from 'immutable';

import * as eduActions from 'modules/edu';
import * as currentStatusActions from 'modules/currentStatus';

import { getFormValues, isValid, reset } from 'redux-form';
import { EduHeader } from 'components';
import * as common from 'libs/commonFunc';

let licenseResult = null;

class CtEduHeader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      isClicked: false,
      isError: false
    };

    this.initEduLicense = this.initEduLicense.bind(this);
    this.onPostEdu = this.onPostEdu.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { EduActions, isModal } = this.props;
    if (prevProps.isModal !== isModal) {
      EduActions.changeEdu({ name: 'eduVideoQuizInfo', value: [] });
    }
  }

  // 성공 실패시 알림창
  onToggleSnackbar = message => {
    const { CurrentStatusActions } = this.props;
    setTimeout(() => {
      CurrentStatusActions.toggleSnackbar({ message: '' });
    }, 5000);

    CurrentStatusActions.toggleSnackbar({ message });
  };

  // 모달 처리
  onToggleModal = viewType => {
    // (태그 추가 모달) 초기화
    const { ReduxFormReset, CurrentStatusActions } = this.props;
    ReduxFormReset('formEduPost');

    CurrentStatusActions.onToggleModal({ viewType: viewType });

    // 에러 초기화
    this.initEduLicense();
  };

  // 교육 실시 모달
  onEduToggleModal = modalType => {
    const { CurrentStatusActions } = this.props;

    this.onToggleModal(modalType);
  };

  // 교육 동영상별 퀴즈 리스트 조회
  onGetVideoQuiz = async () => {
    try {
      const { EduActions, formEduPost, formStore, formEduPostIsValid } = this.props;
      // if (!!formEduPost && !!formEduPostIsValid) {
      const params = {
        eduAttachNo: formStore.values.eduAttachNo
      };

      const respObj = await EduActions.getEduModalQuiz(params);

      if (respObj && respObj.status && respObj.status === 200 && respObj.data) {
        // if (respObj.data.isValidLicense === 0) {
        //   this.setState({ isError: true });
        // } else {
        //   this.onToggleModal('');
        // }
      }
      // } else {
      //   window.markFieldValidate(formStore, 'formEduPost');
      // }
      // this.setState({ isClicked: false });
    } catch (e) {
      console.log(e);
    }
  };

  // 교육 실시(등록)
  onPostEdu = async () => {
    if (!!this.state.isClicked) {
      return false;
    }

    this.setState({
      isLoading: true,
      isClicked: true
    });

    try {
      const { EduActions, formEduPost, formStore, formEduPostIsValid, eduVideoQuizInfo } = this.props;

      if (!!formEduPost && !!formEduPostIsValid) {
        const isSubmit = false;
        const params = {
          eduAttachNo: '',
          eduName: '',
          startEpoch: '',
          endEpoch: '',
          tagNoArray: [],
          examNoArray: []
        };

        params.eduAttachNo = formEduPost.eduAttachNo;
        params.eduName = formEduPost.eduName;
        params.startEpoch = common.epochFromDate(formEduPost.startEpoch);
        params.endEpoch = common.epochFromDate(formEduPost.endEpoch);
        params.tagNoArray = formEduPost.tagNoArray;
        params.examNoArray = formEduPost.examNoArray;

        // 영상별로 선택한 퀴즈 번호들을 하나의 배열에 저장
        const quizNoArray = [];
        eduVideoQuizInfo.map(value => {
          const item = 'quizNoArray' + value.fileNo.toString();
          formEduPost[item] && formEduPost[item].map(quizNo => {
            quizNoArray.push(quizNo);
          });
        });
        if (quizNoArray.length > 0) {
          params.quizNoArray = JSON.stringify(quizNoArray);
        }

        // if (!!this.stateisClicked) {
        const respObj = await EduActions.postEdu(params);

        if (respObj && respObj.status && respObj.status === 200 && respObj.data) {
          // // 대상자가 5명 이하의 경우 라이센스 체크 안함
          // if (respObj.data.targetAllCount < 6) {
          //   // '훈련 가능: 대상자가 5명 이하'
          // } else if (Array.isArray(respObj.data.list) || respObj.data.error) {
          //   licenseResult = respObj.data;
          // }

          // 교육 실시 후 교육 정보 조회(새로고침)
          this.onEduRefresh();

          licenseResult = respObj.data;

          if (respObj.data.isValidLicense === 0) {
            this.setState({ isError: true });
          } else {
            this.onToggleModal('');
          }
        } else {
          console.log('교육 실패');
        }
        // }
      } else {
        window.markFieldValidate(formStore, 'formEduPost');
      }

      this.setState({ isClicked: false });
    } catch (e) {
      console.log(e);
    }
  };

  // 새로 고침
  onEduRefresh = () => {
    const { EduActions } = this.props;
    EduActions.getEdu();

    // 필터 초기화
    EduActions.changeEduTargetParam({
      name: 'filter',
      value: Map({})
    });
  };

  // 교육 실시 라이센스 정보 초기화
  initEduLicense = () => {
    licenseResult = null;

    this.setState({
      isClicked: false,
      isError: false
    });
  };

  // 교육 수정 모달 - 훈련 선택 dropdown
  handleChangeExam = (e, value) => {
    const { CurrentStatusActions } = this.props;

    CurrentStatusActions.changeEduExam({
      selectEduExamNoArray: value
    });
  };

  render() {
    const { initEduLicense, onToggleModal, onEduToggleModal, handleChangeExam, onEduRefresh, onGetVideoQuiz } = this;
    const {
      isModal,
      formStore,
      eduExamByExamNo,
      eduExamOrdering,
      eduAttachOrdering,
      eduAttachByAttachNo,
      eduTargetDataByTargetNo,
      eduSummaryByEduNo,
      eduTagOrdering,
      eduTagByTagNo,
      tagData,
      selectEduNo,
      totalEdu,
      eduVideoQuizInfo
    } = this.props;

    let eduName = '';
    let totalTarget = '';

    if (selectEduNo !== 'all') {
      const data = !!eduSummaryByEduNo && eduSummaryByEduNo.get(String(selectEduNo));

      eduName = !!data && data.get('eduName');
      totalTarget = !!data && data.get('eduCount');
    } else {
      totalTarget = !!eduTargetDataByTargetNo && eduTargetDataByTargetNo.size;
    }

    return (
      <EduHeader
        isModal={isModal}
        formStore={formStore}
        eduExamOrdering={eduExamOrdering}
        eduExamByExamNo={eduExamByExamNo}
        eduAttachOrdering={eduAttachOrdering}
        eduAttachByAttachNo={eduAttachByAttachNo}
        eduTagOrdering={eduTagOrdering}
        selectEduNo={selectEduNo}
        eduName={eduName}
        totalTarget={totalTarget}
        eduTagByTagNo={eduTagByTagNo}
        totalEdu={totalEdu}
        // 버튼 클릭여부
        isClicked={this.state.isClicked}
        isLoading={this.state.isLoading}
        onToggleModal={onToggleModal}
        onEduToggleModal={onEduToggleModal}
        onPostEdu={this.onPostEdu}
        handleChangeExam={handleChangeExam}
        tagData={tagData}
        onEduRefresh={onEduRefresh}
        // 교육 실시 에러
        licenseResult={licenseResult}
        initEduLicense={initEduLicense}
        isError={this.state.isError}
        onGetVideoQuiz={onGetVideoQuiz}
        eduVideoQuizInfo={eduVideoQuizInfo}
      />
    );
  }
}

const mapStateToProps = state => ({
  tagData: state.edu.get('tagDataByTagNo'),
  isModal: state.currentStatus.get('isModal'),
  // 훈련 리스트
  eduExamOrdering: state.edu.get('eduExamOrdering'),
  eduExamByExamNo: state.edu.get('eduExamByExamNo'),
  // 대상자
  eduTargetDataByTargetNo: state.edu.get('eduTargetDataByTargetNo'),
  // 교육
  eduSummaryByEduNo: state.edu.get('eduSummaryByEduNo'),
  // 컨텐츠 리스트
  eduAttachOrdering: state.edu.get('eduAttachOrdering'),
  eduAttachByAttachNo: state.edu.get('eduAttachByAttachNo'),
  // 태그 리스트
  eduTagOrdering: state.edu.get('eduTagOrdering'),
  eduTagByTagNo: state.edu.get('eduTagByTagNo'),
  // 퀴즈 리스트
  eduVideoQuizInfo: state.edu.get('eduVideoQuizInfo'),
  // 선택 된 교육 번호
  selectEduNo: state.currentStatus.getIn(['edu', 'selectEduNo']),
  totalEdu: state.edu.get('totalEdu'),
  formStore: state.form['formEduPost'],
  formEduPost: getFormValues('formEduPost')(state),
  formEduPostIsValid: isValid('formEduPost')(state)
});

const mapDispatchToProps = dispatch => ({
  EduActions: bindActionCreators(eduActions, dispatch),
  CurrentStatusActions: bindActionCreators(currentStatusActions, dispatch),
  ReduxFormReset: bindActionCreators(reset, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CtEduHeader));



// WEBPACK FOOTER //
// ./src/script/containers/edu/CtEduHeader.js